import { memoize } from '../cache/memoize';

export const getIntlNumberFormat = memoize(function getIntlNumberFormat(...args: ConstructorParameters<typeof Intl.NumberFormat>) {
  return new Intl.NumberFormat(...args);
});
